import { create } from 'zustand';

import { DialogProductReplace } from '@components/Alert/templates/DialogProductReplace';
import { useRefAlert } from "@components/Alert";
import { MutableRefObject } from 'react';
import { DialogListToProductTemplate } from '@components/Alert/templates/DialogListToProduct';



interface AddListItemExistsAlert {
  ref: MutableRefObject<useRefAlert | undefined> | undefined,
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  onSuccessCallback: () => void;
  onFailCallback: () => void;
  setOnSuccessCallback: (on: () => {}) => void;
  setOnFailCallback: (on: () => {}) => void;
  text: string | React.ReactElement,
  setWarning: () => void,
  setRef: (ref: MutableRefObject<useRefAlert | undefined>) => void,
}

export const useAddListItemExistsAlert = create<AddListItemExistsAlert>((set, get) => ({
  isOpen: false,
  text: '',
  ref: undefined,
  onSuccessCallback: () => { },
  onFailCallback: () => { },
  setOnSuccessCallback: (onSuccessCallback) => set({ onSuccessCallback }),
  setOnFailCallback: (onFailCallback) => set({ onFailCallback }),
  setRef: (ref) => set({ ref }),
  onOpen: () => {
    set({ isOpen: true })
    get().ref?.current?.show()
  },
  onClose: () => {
    set({ isOpen: false })
    get().onFailCallback()
  },
  setWarning: () => {
    const text = DialogListToProductTemplate();
    set({ text })
  },
}));
